import { render, staticRenderFns } from "./VariantSifterWelcomePanel.vue?vue&type=template&id=7033aada&scoped=true&"
import script from "./VariantSifterWelcomePanel.vue?vue&type=script&lang=js&"
export * from "./VariantSifterWelcomePanel.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterWelcomePanel.vue?vue&type=style&index=0&id=7033aada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7033aada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7033aada')) {
      api.createRecord('7033aada', component.options)
    } else {
      api.reload('7033aada', component.options)
    }
    module.hot.accept("./VariantSifterWelcomePanel.vue?vue&type=template&id=7033aada&scoped=true&", function () {
      api.rerender('7033aada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterWelcomePanel.vue"
export default component.exports